<template>
  <div class="page">
    <div class="content">
      <div class="car-title">
        <div class="car-name">购物车({{ renderAllData.total }})</div>
        <div class="input_dom">
          <!-- <input type="text" class="ipt" />
          <img class="search-icon" src="@/assets/images/search.png" alt="" /> -->
        </div>
      </div>
      <div class="detail">
        <div class="second">
          <div class="info base">商品信息</div>
          <div class="price base">单价</div>
          <div class="count base">数量</div>
          <div class="all_sc base">小计</div>
        </div>
        <ul
          class="third"
          v-infinite-scroll="carLoad"
          :infinite-scroll-distance="50"
        >
          <div class="third_detail" v-for="i in renderData" :key="i.id">
            <div class="third_box">
              <div class="all">
                <input
                  type="checkbox"
                  class="myCheckbox"
                  v-model="i.selected"
                  @click="handleItemClick(i)"
                />
                <div class="img_content">
                  <img :src="i.image" alt="" />
                </div>
              </div>
              <div class="info base">
                {{ i.name }}
              </div>
              <div class="price base">￥{{ formatMoney(i.price) }}</div>
              <div class="count base">
                <div class="left" @click="handleCount('reduce', i.id)">-</div>
                <div class="mid">{{ i.goodsNumber }}</div>
                <div class="right" @click="handleCount('add', i.id)">+</div>
              </div>
              <div class="all_sc base">
                ￥{{ formatMoney(calcItemSubtotal(i)) }}
              </div>
            </div>
          </div>
        </ul>
        <div class="last">
          <div class="left">
            <div class="all">
              <input
                type="checkbox"
                class="myCheckbox"
                v-model="selectAll"
                @change="updataSelect"
              />
              <div class="text">全选</div>
            </div>
            <div class="delete" @click="handleDelete">删除</div>
          </div>
          <div class="right">
            <div class="select_info">
              <div class="text">已选商品</div>
              <div class="count">{{ selectedAllNum }}</div>
              <div class="text">件</div>
            </div>
            <div class="money_info">
              <div class="text">已选商品总金额</div>
              <div class="price">￥{{ formatMoney(selectedAmount) }}</div>
            </div>
            <el-button
              :disabled="selectedAllNum < 1"
              class="submit"
              @click="handleJS"
            >
              结 算
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="back" @click="closeMask('/')">
      <img src="@/assets/images/svg/back.svg" alt="" />
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import {
  getCartList,
  handleCuntSumbit,
  cartSelect,
  cartDelete,
} from "@/api/shopping";
// import { getAddressList } from "@/api/address";
import { useToast } from "vue-toast-notification";
import { ElMessage, ElMessageBox } from "element-plus";
const router = useRouter();
const $toast = useToast();
const closeMask = (url) => {
  router.push(url);
};
const query = ref({
  page: 1,
  size: 5,
  goodsName: "",
});

const renderAllData = ref({
  extraData: {
    selectedAmount: "",
    totalAmount: "",
  },
});
const renderData = ref([]);

const toCents = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100);
};

const fromCents = (cents) => cents / 100;

const formatMoney = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0.00";
  return n.toFixed(2);
};

const calcItemSubtotal = (item) => {
  const unit = toCents(item?.price);
  const count = Math.max(0, Number(item?.goodsNumber) || 0);
  return fromCents(unit * count);
};
//购物车列表
onMounted(() => fetchData());
const fetchData = () => {
  getCartList(query.value).then((res) => {
    const info = res.data.list.map((i) => {
      return { ...i, goodsNumber: i?.goodsNumber || 1 };
    });
    renderData.value = renderData.value.concat(info);
    renderAllData.value = res.data;
    // selectedAmount.value = res.data.extraData.selectedAmount;
  });
};

const carLoad = () => {
  if (
    renderAllData.value.total <
    renderAllData.value.totalPage * renderAllData.value.pageSize
  ) {
    return;
  }
  fetchData();
  query.value.page += 1;
};
// console.log(renderData, "renderData");

// 动态计算全选
const selectAll = computed({
  get: () => renderData.value.every((item) => item.selected),
  set: (value) => {
    renderData.value.forEach((item) => (item.selected = value));
    const ids = renderData.value.map((item) => item.id).toString();
    cartSelect({ selected: value, ids });
  },
});
// const updataSelect = () => {
//   if (selectAll.value) {
//     selectedAmount.value = renderAllData.value.extraData.totalAmount;
//   } else {
//     selectedAmount.value = 0;
//   }
// };

// 动态计算选中商品价格
const selectedAmount = computed(() => {
  const cents = renderData.value
    .filter((item) => item.selected)
    .reduce((acc, item) => {
      const unit = toCents(item.price);
      const count = Math.max(0, Number(item.goodsNumber) || 0);
      return acc + unit * count;
    }, 0);
  return fromCents(cents);
});

// 动态计算商品总数
const selectedAllNum = computed(() => {
  let num = renderData.value
    .filter((item) => item.selected)
    .map(() => 1)
    .reduce((acc, currentValue) => acc + currentValue, 0);
  // updataSelect;
  return num;
});

// 数量加减
const handleCount = (type, id) => {
  const info = renderData.value.filter((res) => res.id === id);
  if (info[0].goodsNumber === 1 && type === "reduce") {
    $toast.error("不能再减啦", {
      position: "top",
    });
    return;
  }
  if (type === "add") {
    info[0].goodsNumber++;
    handleCuntSumbit({ id, count: info[0].goodsNumber });
  } else {
    info[0].goodsNumber--;
    handleCuntSumbit({ id, count: info[0].goodsNumber });
  }
};
//  选择单项的时候
const handleItemClick = (item) => {
  cartSelect({ selected: !item.selected, ids: item.id });
};
const handleDelete = () => {
  ElMessageBox.confirm("请确认是否删除商品?", "提示", {
    confirmButtonText: "OK",
    cancelButtonText: "Cancel",
    type: "warning",
  })
    .then(() => {
      const ids = renderData.value
        .filter((res) => res.selected)
        .map((item) => +item.id);
      // console.log(ids);
      cartDelete({ ids }).then(() => {
        renderData.value = [];
        query.value.page = 1;
        fetchData();
      }); // 传递字符串
    })
    .catch(() => {});
};
// 结算
const handleJS = () => {
  const info = renderData.value
    .filter((item) => item.selected)
    .map((res) => {
      return { cartId: res.id };
    });
  if (!info.length) {
    ElMessage.warning("请先勾选要结算的商品");
    return;
  }
  const data = encodeURIComponent(JSON.stringify(info));
  router.push(`/sureOrder/${data}`);
};
</script>
<style scoped lang="scss">
.page {
  // height: 1080.002px;
  background-color: transparent;
  position: relative;
  padding: 86px 240px 0 240px;
}
.content {
  width: 1200px;
  margin: 0 auto;
}
.detail {
  min-height: 854px;
  background-color: var(--ux-glass-bg);
  border: 0.5px solid var(--ux-glass-border);
  backdrop-filter: var(--ios-glass-blur-light);
  -webkit-backdrop-filter: var(--ios-glass-blur-light);
  box-shadow: var(--ux-glass-shadow);
  border-radius: 30px;
  position: relative;
  margin-bottom: 30px;
  .first {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    .left {
      padding: 35px 0 18px 0px;
      font-weight: 400;
      font-size: 32px;
      color: var(--ux-text-primary);
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
    .right {
      display: flex;
      .mark {
        font-weight: 400;
        font-size: 20px;
        color: var(--ux-text-primary);
        line-height: 23px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .price {
        margin: 0 36px 0 49px;
        font-weight: bold;
        font-size: 36px;
        color: #ff0000;
        line-height: 24px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }
  }
  .second {
    display: flex;
    padding: 20px 50px 20px 75px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.18);
    .base {
      font-weight: 400;
      font-size: 20px;
      color: var(--ux-text-primary);
      line-height: 23px;
      font-style: normal;
      text-transform: none;
    }
    .info {
      flex: 14;
    }
    .price {
      flex: 3;
    }
    .count {
      flex: 5;
    }
    .all_sc {
      flex: 3;
    }
  }
  .last {
    padding: 0 49.994px 0 49.994px;
    border-top: 1px solid rgba(255, 255, 255, 0.18);
    height: 94px;
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 1199.996px;
    background: var(--ux-glass-bg-header, rgba(255, 255, 255, 0.06));
    backdrop-filter: var(--ios-glass-blur-heavy, saturate(200%) blur(32px));
    -webkit-backdrop-filter: var(
      --ios-glass-blur-heavy,
      saturate(200%) blur(32px)
    );
    box-shadow: inset 0 1px 0
      var(--ux-glass-highlight, rgba(255, 255, 255, 0.14));
    border-radius: 0 0 30px 30px;
    .left {
      display: flex;
      align-items: center;
      .all {
        display: flex;
        margin-right: 135.8px;
        .myCheckbox {
          margin-right: 14px;
          width: 20.006px;
          height: 20.006px;
          &:hover {
            cursor: pointer;
          }
        }
        .text {
          font-size: 20px;
        }
      }
      .delete {
        font-size: 20px;
        cursor: pointer;
      }
    }
    .right {
      display: flex;
      align-items: center;
      .select_info {
        display: flex;
        align-items: center;
        .text {
          font-weight: 400;
          font-size: 20.006px;
          color: var(--ux-text-primary);
          line-height: 23.002px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
        .count {
          width: 14.994px;
          height: 23.996px;
          margin: 0 21.994px;
          font-weight: bold;
          font-size: 23.996px;
          color: #ff0000;
          line-height: 23.996px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
      }
      .money_info {
        display: flex;
        margin: 0 49.994px;
        align-items: center;
        .text {
          font-weight: 400;
          font-size: 20.006px;
          color: var(--ux-text-primary);
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
        .price {
          font-weight: bold;
          font-size: 23.996px;
          color: #ff0000;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
      }
      .submit {
        width: 152px;
        height: 58px;
        background: linear-gradient(
          135deg,
          var(--ux-accent, #00d4ff) 0%,
          var(--ux-accent-2, #7c3aed) 100%
        );
        border-radius: 49.994px 49.994px 49.994px 49.994px;
        border: none;
        font-weight: 600;
        font-size: 24px;
        color: #fff;
        line-height: 58.002px;
        text-align: center;
        cursor: pointer;
        box-shadow: 0 8px 20px rgba(0, 212, 255, 0.28);
      }
      .submit.is-disabled,
      .submit[disabled] {
        background: rgba(255, 255, 255, 0.18);
        color: rgba(255, 255, 255, 0.6);
        box-shadow: none;
      }
    }
  }
}
.back {
  position: absolute;
  right: 28px;
  top: 28px;
  width: 48.006px;
  &:hover {
    cursor: pointer;
  }
}
.car-title {
  display: flex;
  padding: 75px 0 30px 0;
  align-items: center;
  .car-name {
    width: 346x;
    height: 51px;
    font-weight: bold;
    font-size: 40px;
    color: var(--ux-text-primary);
    line-height: 46.998px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    // margin-left: 48px;
  }
  .input_dom {
    margin-left: 56px;
    display: flex;
    align-items: center;
    input {
      width: 361px;
      height: 37.996px;
      background: var(--ux-surface-muted);
      border-radius: 18.998px 18.998px 18.998px 18.998px;
      opacity: 0.5;
      border: none;
    }
    .search-icon {
      width: 24px;
      height: 24px;
      margin-left: 5px;
    }
  }
}

.third {
  max-height: 620px;
  list-style: none;
  overflow: auto;
  width: 100%;
  padding: 0 20px;
  .third_detail {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    padding: 20px 0;
  }
}
.third_box {
  padding: 20px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  display: flex;
  margin-bottom: 18px;
  .all {
    display: flex;
    .myCheckbox {
      margin-right: 14px;
      width: 20px;
      height: 20px;
      display: block;
      &:hover {
        cursor: pointer;
      }
    }
    .img_content {
      height: 100%;
      display: flex;
      align-items: center;
      img {
        width: 125px;
        height: 125px;
        border-radius: 12px;
        object-fit: cover;
      }
    }
  }
  .base {
    font-weight: 400;
    font-size: 20px;
    color: var(--ux-text-primary);
    line-height: 23px;
    text-align: justified;
    font-style: normal;
    text-transform: none;
  }
  .info {
    flex: 14;
    padding: 0 10px;
  }
  .price {
    flex: 4;
    font-weight: bold;
  }
  .count {
    flex: 7;
    display: flex;
    align-items: center;
    .left {
      width: 40px;
      height: 40px;
      background: rgba(255, 255, 255, 0.14);
      border-radius: 42px 42px 42px 42px;
      font-weight: bold;
      font-size: 20.006px;
      color: var(--ux-text-primary);
      line-height: 39.998px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      &:hover {
        cursor: pointer;
      }
    }
    .mid {
      width: 71px;
      height: 40px;
      background: rgba(0, 0, 0, 0.22);
      border-radius: 5px 5px 5px 5px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      color: var(--ux-text-primary);
      line-height: 39.998px;
      text-align: center;
      margin: 0 9.8px;
      font-weight: bold;
    }
    .right {
      width: 40px;
      height: 40px;
      background: rgba(255, 255, 255, 0.14);
      border-radius: 42px 42px 42px 42px;
      font-weight: bold;
      font-size: 20px;
      color: var(--ux-text-primary);
      line-height: 40px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .all_sc {
    flex: 4;
    font-weight: bold;
    font-size: 20px;
    color: #ff0000;
    font-style: normal;
    text-transform: none;
  }
}
</style>
